function formatDate(inputDate) {
  if (!inputDate) {
    return "-";
  }

  let date;

  if (inputDate instanceof Date) {
    date = inputDate;
  } else if (typeof inputDate === "string") {
    const trimmed = inputDate.trim();

    if (!trimmed) {
      return "-";
    }

    // Supporte explicitement les dates au format DD/MM/YYYY.
    if (trimmed.includes("/")) {
      const parts = trimmed.split("/");
      if (parts.length === 3) {
        const [day, month, year] = parts;
        date = new Date(`${year}-${month}-${day}`);
      } else {
        date = new Date(trimmed);
      }
    } else {
      // ISO et autres formats parsables par Date.
      date = new Date(trimmed);
    }
  } else if (typeof inputDate === "number") {
    date = new Date(inputDate);
  } else {
    return "-";
  }

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export {formatDate}